import { APP_API_V1_BASE } from "../../../config/api";
// import { useEffect, useState } from "react";
// import {
//   Paper,
//   Typography,
//   Stack,
//   FormControlLabel,
//   Switch,
//   CircularProgress,
//   Box,
// } from "@mui/material";
// import axios from "axios";

// const API_BASE = `${APP_API_V1_BASE}`;

// export default function NotificationsTab({ activeOrg, headers }) {
//   const [settings, setSettings] = useState({
//     email_enabled: false,
//     sms_enabled: false,
//     webhook_enabled: false,
//   });

//   const [loading, setLoading] = useState(false);

//   /* ---------------------------------------
//      Load Notification Settings
//   --------------------------------------- */
//   const loadSettings = async () => {
//     if (!activeOrg?.id) return;

//     try {
//       setLoading(true);

//       const res = await axios.get(
//         `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
//         { headers }
//       );

//       setSettings(res.data);
//     } catch (err) {
//       console.error("Failed to load notification settings", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadSettings();
//   }, [activeOrg]);

//   /* ---------------------------------------
//      Toggle Handler
//   --------------------------------------- */
//   const handleToggle = async (key, value) => {
//     if (!activeOrg?.id) return;

//     try {
//       setSettings((prev) => ({
//         ...prev,
//         [key]: value,
//       }));

//       await axios.patch(
//         `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
//         { [key]: value },
//         { headers }
//       );
//     } catch (err) {
//       console.error("Failed to update notification setting", err);

//       // rollback if failed
//       setSettings((prev) => ({
//         ...prev,
//         [key]: !value,
//       }));
//     }
//   };

//   if (!activeOrg) {
//     return (
//       <Paper sx={{ p: 3 }}>
//         <Typography color="text.secondary">
//           No active organization selected.
//         </Typography>
//       </Paper>
//     );
//   }

//   return (
//     <Paper sx={{ p: 3 }}>
//       <Typography variant="h6" fontWeight={600} mb={3}>
//         Notification Channels
//       </Typography>

//       {loading ? (
//         <Box display="flex" justifyContent="center">
//           <CircularProgress size={28} />
//         </Box>
//       ) : (
//         <Stack spacing={3}>
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={settings.email_enabled}
//                 onChange={(e) =>
//                   handleToggle("email_enabled", e.target.checked)
//                 }
//               />
//             }
//             label="Email Notifications"
//           />

//           <FormControlLabel
//             control={
//               <Switch
//                 checked={settings.sms_enabled}
//                 onChange={(e) =>
//                   handleToggle("sms_enabled", e.target.checked)
//                 }
//               />
//             }
//             label="SMS Notifications"
//           />

//           <FormControlLabel
//             control={
//               <Switch
//                 checked={settings.webhook_enabled}
//                 onChange={(e) =>
//                   handleToggle("webhook_enabled", e.target.checked)
//                 }
//               />
//             }
//             label="Webhook Notifications"
//           />
//         </Stack>
//       )}
//     </Paper>
//   );
// }

import { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  FormControlLabel,
  Switch,
  CircularProgress,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";
import axios from "axios";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import WebhookIcon from "@mui/icons-material/Hub";
import { useNotification } from "../../../context/NotificationContext";
const API_BASE = `${APP_API_V1_BASE}`;

export default function NotificationsTab({ activeOrg, headers }) {
  const { showNotification } = useNotification();
  
  const [settings, setSettings] = useState({
    email_enabled: false,
    sms_enabled: false,
    webhook_enabled: false,
  });

  const [loading, setLoading] = useState(false);
  const [cardPage, setCardPage] = useState(0);
  const cardPageSize = 6; // cards per page
  // ✅ FIX: Error feedback so user knows when a save failed (not just a silent rollback)
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  /* ---------------------------------------
     Load Notification Settings
  --------------------------------------- */
  const loadSettings = async () => {
    if (!activeOrg?.id) return;

    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
        { headers },
      );
      setSettings(res.data);
    } catch (err) {
      console.error("Failed to load notification settings", err);
      // setToast({
      //   open: true,
      //   message: "Failed to load notification settings.",
      //   severity: "error",
      // });
      showNotification(
  "Failed to load notification settings.",
  "error"
);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, [activeOrg?.id]);

  /* ---------------------------------------
     Toggle Handler — optimistic update + rollback
  --------------------------------------- */
  const handleToggle = async (key, value) => {
    if (!activeOrg?.id) return;

    // Optimistic update
    setSettings((prev) => ({ ...prev, [key]: value }));

    try {
      await axios.patch(
        `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
        { [key]: value },
        { headers },
      );
    } catch (err) {
      console.error("Failed to update notification setting", err);

      // ✅ FIX: Rollback AND show feedback — user knows why the toggle snapped back
      setSettings((prev) => ({ ...prev, [key]: !value }));
      setToast({
        open: true,
        message: "Failed to save setting. Please try again.",
        severity: "error",
      });
    }
  };

  if (!activeOrg) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography color="text.secondary">
          No active organization selected.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: "1px solid #e5e7eb",
        backgroundColor: "#ffffff",
      }}
    >
      <Typography variant="h6" fontWeight={600} mb={1.5}>
        Notification Channels
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Stack spacing={3}>
          <FormControlLabel
            control={
              <Switch
                checked={settings.email_enabled}
                onChange={(e) =>
                  handleToggle("email_enabled", e.target.checked)
                }
              />
            }
            label="Email Notifications"
          />

          <FormControlLabel
            control={
              <Switch
                checked={settings.sms_enabled}
                onChange={(e) => handleToggle("sms_enabled", e.target.checked)}
              />
            }
            label="SMS Notifications"
          />

          <FormControlLabel
            control={
              <Switch
                checked={settings.webhook_enabled}
                onChange={(e) =>
                  handleToggle("webhook_enabled", e.target.checked)
                }
              />
            }
            label="Webhook Notifications"
          />
        </Stack>
      )}

      {/* Toast */}
      {/* <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((t) => ({ ...t, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast((t) => ({ ...t, open: false }))}
          severity={toast.severity}
          variant="filled"
        >
          {toast.message}
        </Alert>
      </Snackbar> */}
    </Paper>
  );
}
